module.exports = __webpack_public_path__ + "media/images/about-logo-dw-b71a2ea9cb6879b76dbcb3f58c129443.png";